import { render, staticRenderFns } from "./v20a1000detail.vue?vue&type=template&id=77d8d972&scoped=true&"
import script from "./v20a1000detail.vue?vue&type=script&lang=js&"
export * from "./v20a1000detail.vue?vue&type=script&lang=js&"
import style0 from "./v20a1000detail.vue?vue&type=style&index=0&id=77d8d972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d8d972",
  null
  
)

export default component.exports